import Utils from '../../Utils';
import Analytics from './Analytics';

export default class Form {

    static initializeEvents() {
        this.addEventsToForms();
        this.addEventsToSelects();
        this.addEventsToPasswordInputs();
        this.scrollToParentIframe();
    }

    static scrollToParentIframe() {
        window.addEventListener("message", function(event) {
            if (event.data.action === "scrollToIframe") {
                let iframes = document.querySelectorAll("iframe");
                for (let iframe of iframes) {
                    if (iframe.contentWindow === event.source) {
                        iframe.scrollIntoView({ behavior: "smooth", block: "start" });
                        break;
                    }
                }
            }
        });
    }

    static addEventsToForms() {
        Array
            .from(document.querySelectorAll('form[data-form-current-step]'))
            .forEach(form => {
                Analytics.push('Formulaires', form.action.split('/').pop(), 'Vue');

                Array
                    .from(form.querySelectorAll('button[data-form-step-button]'))
                    .forEach(button => button.addEventListener('click', event => {
                        event.preventDefault();

                        // Validate current step fields
                        if (button.getAttribute('data-form-step-button') === 'next') {
                            let stepHasError = false;
                            Array
                                .from(Utils.parent(event.currentTarget, '[data-form-step-index]').querySelectorAll('.input-group'))
                                .forEach(group => {
                                    group.dispatchEvent(new Event('focusout'));

                                    if (group.classList.contains('input-group-error')) {
                                        stepHasError = true;
                                    }
                                });

                            // Disabled with errors
                            if (stepHasError) {
                                return;
                            }
                        }

                        // Close all steps
                        Array.from(form.querySelectorAll('[data-form-step-index]')).forEach(step => step.classList.add('hidden'));

                        let currentStepIndex = parseInt(form.getAttribute('data-form-current-step'));
                        let targetStepIndex = button.getAttribute('data-form-step-button') === 'prev' ? (currentStepIndex - 1) : (currentStepIndex + 1);

                        // Open current step
                        let targetStepElement = form.querySelector('[data-form-step-index="' + targetStepIndex + '"]');
                        if (targetStepElement) {
                            // Allow step fields validation
                            Array
                                .from(targetStepElement.querySelectorAll('[data-form-field-required]'))
                                .forEach(input => {
                                    input.required = true;
                                    input.removeAttribute('data-form-field-required');
                                });

                            // Skip step
                            if (targetStepElement.hasAttribute('data-form-step-skip')) {
                                const targetStepSkip = JSON.parse(targetStepElement.getAttribute('data-form-step-skip'));

                                Object.keys(targetStepSkip).forEach(inputName => {
                                    const inputValues = targetStepSkip[inputName];
                                    const skipInputElement = form.querySelector('[name="' + inputName + '"]');

                                    if (skipInputElement && inputValues.includes(skipInputElement.value)) {
                                        // Remove step fields validation
                                        Array
                                            .from(targetStepElement.querySelectorAll('input[required], select[required], textarea[required]'))
                                            .forEach(input => {
                                                input.required = false;
                                                input.setAttribute('data-form-field-required', '');
                                            });

                                        targetStepIndex = button.getAttribute('data-form-step-button') === 'prev' ? (currentStepIndex - 2) : (currentStepIndex + 2);
                                        targetStepElement = form.querySelector('[data-form-step-index="' + targetStepIndex + '"]');
                                    }
                                });
                            }

                            targetStepElement.classList.remove('hidden');

                            if (button.getAttribute('data-form-step-button') === 'next') {
                                Analytics.push('Formulaires', form.action.split('/').pop(), 'Passage à l\'étape ' + (targetStepIndex + 1));
                            }

                            const confirmationElement = targetStepElement.querySelector('[data-form-confirmation]');
                            if (confirmationElement) {
                                this.addFormConfirmation(confirmationElement);
                            }
                        }

                        form.setAttribute('data-form-current-step', targetStepIndex);

                        // Update of stepper
                        Array.from(form.querySelectorAll('[data-form-stepper-current]')).forEach(item => item.innerText = targetStepIndex + 1);
                        Array.from(form.querySelectorAll('[data-form-stepper-label]')).forEach(item => item.innerText = targetStepElement.getAttribute('data-form-step-label'));

                        form.querySelector('.stepper-steps').style.setProperty('--current-step', targetStepIndex + 1);

                        const nextStepElement = form.querySelector('[data-form-step-index="' + (targetStepIndex + 1) + '"]');
                        if (nextStepElement) {
                            form.querySelector('[data-form-stepper-next]').innerText = nextStepElement.getAttribute('data-form-step-label');
                            form.querySelector('[data-form-stepper-next]').parentNode.classList.remove('hidden');
                            form.querySelector('[data-form-stepper-next]').parentNode.removeAttribute('aria-hidden');
                        } else {
                            form.querySelector('[data-form-stepper-next]').parentNode.classList.add('hidden');
                            form.querySelector('[data-form-stepper-next]').parentNode.setAttribute('aria-hidden', true);
                        }
                    }));
            });
    }

    static addEventsToSelects() {
        Array
            .from(document.querySelectorAll('select[data-form-option-child-field]'))
            .forEach(select => select.addEventListener('change', event => {
                const childSelect = document.querySelector('select[name="' + event.currentTarget.getAttribute('data-form-option-child-field') + '"]');

                // Hide all options
                Array
                    .from(childSelect.querySelectorAll('option[data-form-option-parent-value]'))
                    .forEach(option => {
                        option.classList.add('hidden');
                        option.setAttribute('disabled', '');
                    });

                // Show nested options
                Array
                    .from(childSelect.querySelectorAll('option[data-form-option-parent-value="' + event.currentTarget.value + '"]'))
                    .forEach(option => {
                        option.classList.remove('hidden');
                        option.removeAttribute('disabled');
                    });

                // Reset select value
                childSelect.value = '';

                // Disable select without option
                if (!childSelect.querySelector('option[data-form-option-parent-value]:not(:disabled)')) {
                    childSelect.setAttribute('disabled', '');
                } else {
                    childSelect.removeAttribute('disabled');
                }

                // Trigger a change event to support nested fields
                childSelect.dispatchEvent(new Event('change'));
            }));
    }

    static addFormConfirmation(confirmationElement) {
        confirmationElement.innerHTML = '';

        const fields = Array
            .from(Utils.parent(confirmationElement, 'form').querySelectorAll('[name]'))
            .map(field => {
                const step = Utils.parent(field, '[data-form-step-label]');

                let label, value;
                if (field.getAttribute('type') === 'radio') {
                    label = field.parentNode.querySelector('label[for="' + field.id + '"]');
                    value = field.checked ? (label ? label.innerText : '') : '';
                    label = field.parentNode.parentNode.querySelector('legend');
                } else {
                    label = field.parentNode.querySelector('label[for="' + field.id + '"]');
                    value = field.value;
                }

                return {
                    step_index: step ? parseInt(step.getAttribute('data-form-step-index')) : '',
                    step_label: step ? step.getAttribute('data-form-step-label') : '',
                    label: label ? label.innerText : '',
                    value: value
                }
            })
            .filter(field => field.step_label !== '' && field.label !== '' && field.value !== '');

        const groupedFields = new Map();

        fields.forEach(field => {
            if (!groupedFields.has(field.step_label)) {
                groupedFields.set(field.step_label, []);
            }
            groupedFields.get(field.step_label).push(field);
        });

        for (let [label, fields] of groupedFields) {
            const stepElement = document.createElement('div');
            stepElement.classList.add('py-2w', 'border-t-grey');
            confirmationElement.appendChild(stepElement);

            // Step label
            const stepLabelElement = document.createElement('h3');
            stepLabelElement.innerText = label;
            stepElement.appendChild(stepLabelElement);

            // Step fields
            const stepFieldsElement = document.createElement('ul');
            fields.forEach(field => {
                const fieldLabelElement = document.createElement('li');
                fieldLabelElement.innerText = field.label + ' : ' + field.value;
                stepFieldsElement.appendChild(fieldLabelElement);
            });
            stepElement.appendChild(stepFieldsElement);
        }
    }

    static addEventsToPasswordInputs() {
        const passwordInputs = document.querySelectorAll('input[type="password"]');

        passwordInputs.forEach(passwordInput => {
            const containerDiv = document.createElement('div');
            containerDiv.className = 'relative';

            const toggleButton = document.createElement('button');
            toggleButton.type = 'button';
            toggleButton.className = 'toggle-password-visibility';
            toggleButton.setAttribute('aria-hidden', 'true');

            const eyeIcon = document.createElement('i');
            eyeIcon.className = 'ri-eye-line';
            toggleButton.appendChild(eyeIcon);

            const eyeOffIcon = document.createElement('i');
            eyeOffIcon.className = 'ri-eye-off-line hidden';
            toggleButton.appendChild(eyeOffIcon);

            passwordInput.parentNode.insertBefore(containerDiv, passwordInput);
            containerDiv.appendChild(passwordInput);
            containerDiv.appendChild(toggleButton);

            toggleButton.addEventListener('click', function () {
                if (passwordInput.type === 'password') {
                    passwordInput.type = 'text';
                    eyeIcon.classList.add('hidden');
                    eyeOffIcon.classList.remove('hidden');
                    toggleButton.setAttribute('title', 'Masquer le mot de passe');
                } else {
                    passwordInput.type = 'password';
                    eyeIcon.classList.remove('hidden');
                    eyeOffIcon.classList.add('hidden');
                    toggleButton.setAttribute('title', 'Afficher le mot de passe');
                }
            });
        });
    }
}